import api from "./axiosInstance";
import networkConfig from "../utils/networkConfig";

export const sendNotification = async (data) => {
  const res = await api.post(networkConfig.notification, data);
  return res.data;
};
